import axios from "axios";

const axiosPublic = axios.create({
    withCredentials: true,
    baseURL: "",
});

const axiosPrivate = axios.create({
    withCredentials: true,
    baseURL: "",
});

export { axiosPublic, axiosPrivate };
